import React from "react";
import { useQueryClient } from "@tanstack/react-query";

import MainLayout from "components/MainLayout";
import MainList from "components/MainList";

import getColumns from "./columns";
import CreateIssueModal from "components/create_modals/CreateIssueModal";
import { useWorkers } from "context/providers/workers";
import { useIssueKinds } from "context/providers/issue_kinds";
import { useAuth } from "context/providers/auth";

const IssuesList = () => {
  const queryClient = useQueryClient();
  const {
    state: {
      user: { issues_index_columns },
    },
    updateUserIssueIndexColumns,
  } = useAuth();
  const { workers_list_options } = useWorkers();
  const { issue_kind_options } = useIssueKinds();

  const onSuccess = () =>
    queryClient.refetchQueries({
      queryKey: ["issues"],
    });

  const columns_data = getColumns(
    workers_list_options,
    issue_kind_options,
    issues_index_columns
  );

  return (
    <MainLayout
      breadcrumbs={[{ name: "Zgłoszenia" }]}
      buttons={<CreateIssueModal onSuccess={onSuccess} />}
    >
      <div className="issues-table">
        <MainList
          columns={columns_data}
          query_name="issues"
          query_path="/issues"
          navigation_path="/issues"
          query_context="index"
          default_sort="service_date__desc"
          ls_key="issues_index"
          selectable
          show_checklist={true}
          checked_list={issues_index_columns}
          updateCheckedList={updateUserIssueIndexColumns}
          default_ls_query={
            { issue_type: { search_method: "in", value: [0, 1] } }
          }
          default_ls_search_values={
            { issue_type: [0, 1] }
          }
        />
      </div>
    </MainLayout>
  );
};

export default IssuesList;
